module.exports = {
  year: ' year{0}',
  month: ' month{0}',
  week: ' week{0}',
  day: ' day{0}',
  hour: ' hour{0}',
  minute: ' minute{0}',
  second: ' second{0}',
  ago: '{0} ago',
  in: 'in {0}',
  now: 'right now'
}



// WEBPACK FOOTER //
// ./~/rctui/lang/en/timeago.js